import createIcon from '../../createIcon';

/**
 * @component @name PriceChange
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgNEg0QzIuODkgNCAyLjAxIDQuODkgMi4wMSA2TDIgMThDMiAxOS4xMSAyLjg5IDIwIDQgMjBIMjBDMjEuMTEgMjAgMjIgMTkuMTEgMjIgMThWNkMyMiA0Ljg5IDIxLjExIDQgMjAgNFpNMTIgMTBIOFYxMUgxMUMxMS41NSAxMSAxMiAxMS40NSAxMiAxMlYxNUMxMiAxNS41NSAxMS41NSAxNiAxMSAxNkgxMFYxN0g4VjE2SDZWMTRIMTBWMTNIN0M2LjQ1IDEzIDYgMTIuNTUgNiAxMlY5QzYgOC40NSA2LjQ1IDggNyA4SDhWN0gxMFY4SDEyVjEwWk0xNiAxNi4yNUwxNCAxNC4yNUgxOEwxNiAxNi4yNVpNMTQgMTBMMTYgOEwxOCAxMEgxNFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PriceChange = createIcon('PriceChange', [
  [
    'path',
    {
      d: 'M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM12 10H8V11H11C11.55 11 12 11.45 12 12V15C12 15.55 11.55 16 11 16H10V17H8V16H6V14H10V13H7C6.45 13 6 12.55 6 12V9C6 8.45 6.45 8 7 8H8V7H10V8H12V10ZM16 16.25L14 14.25H18L16 16.25ZM14 10L16 8L18 10H14Z',
      key: '1azk07',
    },
  ],
]);

export default PriceChange;
